// Auto-generated companion to the landing Universal section (redesign 5/n).
// One native demo sentence per language — displayed in the language the
// visitor selects, INDEPENDENT of the current UI locale, so the section
// proves native support (incl. RTL Arabic). Language metadata (flag / native
// name / dir) comes from the single-source `languages` array in src/i18n.js.
export const LANG_SAMPLES = {
  fr: "L'IA personnalise l'apprentissage au rythme de chacun.",
  en: "AI tailors learning to each person's own pace.",
  de: "Die KI passt das Lernen dem Tempo jedes Einzelnen an.",
  es: "La IA personaliza el aprendizaje al ritmo de cada persona.",
  it: "L'IA personalizza l'apprendimento sul ritmo di ciascuno.",
  pt: "A IA personaliza a aprendizagem no ritmo de cada um.",
  nl: "AI stemt het leren af op ieders eigen tempo.",
  pl: "SI dopasowuje naukę do tempa każdego z osobna.",
  ru: "ИИ подстраивает обучение под темп каждого.",
  tr: "Yapay zekâ öğrenmeyi herkesin kendi hızına göre uyarlar.",
  ar: "يُخصِّص الذكاء الاصطناعي التعلُّم وفق إيقاع كل شخص.",
  hi: "एआई सीखने को हर किसी की अपनी रफ़्तार के मुताबिक ढालता है।",
  ja: "AIが一人ひとりのペースに合わせて学びを最適化します。",
  ko: "AI가 각자의 속도에 맞춰 학습을 맞춤화합니다.",
  zh: "AI 按照每个人的节奏定制学习。",
};
